var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.2,
    height: 28.601,
    viewBox: "0 0 29.2 28.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logout-svgrepo-com",
    d: "M108.119,103.616h-2.338a.524.524,0,0,0-.409.193,10.76,10.76,0,0,1-.745.815,11.777,11.777,0,1,1,0-16.649c.263.263.509.535.745.815a.529.529,0,0,0,.409.193h2.338a.265.265,0,0,0,.223-.409,14.3,14.3,0,1,0,0,15.451A.266.266,0,0,0,108.119,103.616Zm2.957-7.526-4.719-3.725a.266.266,0,0,0-.432.21V95.1H95.481a.267.267,0,0,0-.266.266V97.23a.267.267,0,0,0,.266.266h10.443v2.528a.267.267,0,0,0,.432.21l4.719-3.725a.266.266,0,0,0,0-.419Z",
    transform: "translate(-81.978 -81.999)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.39709784679c86c756ae0924d36feed9.svg";
export { ForwardRef as ReactComponent };